/* Shared loading / empty / error states for API-driven screens.
   Reuses the module's existing .stub / .card styling so the look is
   unchanged — these only fill the gap while data loads or is absent. */
import React from 'react';

export function Loading({ label = 'Loading…' }) {
	return (
		<div className="stub" aria-busy="true">
			<div className="stub__title">{label}</div>
			<div>One moment while we fetch the latest from Diligentsia.</div>
		</div>
	);
}

export function EmptyState({ title = 'Nothing here yet', sub = '' }) {
	return (
		<div className="stub">
			<div className="stub__title">{title}</div>
			{sub ? <div>{sub}</div> : null}
		</div>
	);
}

export function ErrorState({ title = 'Could not load this', sub = 'Please try again.', onRetry }) {
	return (
		<div className="stub">
			<div className="stub__title">{title}</div>
			<div>{sub}</div>
			{onRetry ? <button className="pill pill--outline" style={{ marginTop: 12 }} onClick={onRetry}>Retry</button> : null}
		</div>
	);
}
